"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentResourceEnhancerSchema = void 0;
var zod_1 = require("zod");
var content_resource_1 = require("./content-resource");
exports.ContentResourceEnhancerSchema = zod_1.z
    .function()
    .args(content_resource_1.ContentResourceSchema.passthrough())
    .returns(zod_1.z.union([content_resource_1.ContentResourceSchema, zod_1.z.promise(content_resource_1.ContentResourceSchema)]))
    .nullable();
//# sourceMappingURL=content-resource-enhancer.js.map